import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { computed } from 'vue'

export type ButtonType = 'Primary' | 'Secondary' | 'Highlighted'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalButton',
  props: {
  text: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  buttonType: {
    type: String as () => ButtonType, // Set the type to ButtonType
    required: true
  }
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

var props = __props

const emit = __emit

const handleClick = () => {
  emit('click')
}

// Compute the button class based on the buttonType prop
const buttonClass = computed(() => {
  switch (props.buttonType) {
    case 'Primary':
      return 'ms-btn-primary'
    case 'Secondary':
      return 'ms-btn-secondary'
    case 'Highlighted':
      return 'ms-btn-highlighted'
    default:
      return ''
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["ms-button btn", buttonClass.value]),
    disabled: __props.disabled,
    type: "button",
    onClick: handleClick
  }, _toDisplayString(__props.text), 11, _hoisted_1))
}
}

})